import { SelectInput } from "~/components/SelectInput";

import { AggregateQueryInterval } from "~/modules/filters/types";
import { cn } from "~/lib/utils";
import { useWindowSize } from "~/utils/useWindowSize";

// // // //

const intervalOptions: Record<AggregateQueryInterval, string> = {
    [AggregateQueryInterval.day]: "Daily",
    [AggregateQueryInterval.week]: "Weekly",
    [AggregateQueryInterval.month]: "Monthly",
    [AggregateQueryInterval.quarter]: "Quarterly",
    [AggregateQueryInterval.year]: "Yearly",
};

// // // //

export function AggregateIntervalControls(props: {
    value: AggregateQueryInterval;
    allowedOptions: AggregateQueryInterval[];
    onChange: (updated: AggregateQueryInterval) => void;
    /**
     * Below the `@2xl` container breakpoint, stack the label above the select
     * and let the control fill its container instead of sitting inline at a
     * fixed width. Requires an `@container` ancestor — TimeseriesCard's control
     * bar provides one.
     */
    stackLabelOnNarrow?: boolean;
}) {
    const {
        value,
        allowedOptions,
        onChange,
        stackLabelOnNarrow = false,
    } = props;

    const { isSm, isMd } = useWindowSize();
    const showInsetLabel = isSm || isMd;

    return (
        <div
            className={cn("flex items-center gap-2", {
                "w-full min-w-0 flex-col items-start gap-1 @2xl:w-auto @2xl:flex-row @2xl:items-center @2xl:gap-2":
                    stackLabelOnNarrow,
            })}
        >
            {!showInsetLabel && (
                <p className="text-sm font-semibold text-foreground whitespace-nowrap select-none">
                    Interval
                </p>
            )}

            <SelectInput
                size="sm"
                value={value}
                placeholder="Interval"
                placeholderPosition={showInsetLabel ? "inset" : "hidden"}
                className={cn({
                    "@2xl:w-42 w-full min-w-0": stackLabelOnNarrow,
                })}
                onChange={(updatedValue) => {
                    onChange(updatedValue as AggregateQueryInterval);
                }}
                options={allowedOptions.map((opt) => ({
                    value: opt,
                    content: {
                        label: intervalOptions[opt],
                    },
                }))}
            />
        </div>
    );
}
